/** The one date style the portal uses: 1 June 2026. */

const DATE_FORMAT = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

/** @param epochMs Epoch milliseconds, as every timestamp on the wire is. */
export function formatDate(epochMs: number): string {
  return DATE_FORMAT.format(new Date(epochMs));
}
